// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Label_componentWrapper__e7ERX","new":"Label_new__YrB1f","bestseller":"Label_bestseller__3-Qrf","promotion":"Label_promotion__iV+NK"};